import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import Swal from "sweetalert2";
import BaseUrl from "../Components/BaseUrl";
import { GoogleLogin } from "@react-oauth/google";

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState({
    email: "",
    password: "",
    
  });
  const [showPassword, setShowPassword] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
    setError({ ...error, [id]: "" });
  };

  const validateForm = () => {
    let result = true;
    let errors = {};
    if (formData.email.trim() === "") {
      errors.email = "please enter an email address";
      result = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "Email is invalid!";
      result = false;
    }
    if (formData.password === "") {
      errors.password = "please enter a password";
      result = false;
    }
    setError(errors);
    return result;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = validateForm();
    if (result) {
      setIsLoading(true);
      try {
        const response = await axios.post(BaseUrl + "login", formData);
   
        if (response.data.status === 200) {
          console.log(response.data.data.steps);
          if(response.data.data.steps < 8){
            Cookies.set("userId", response.data.data.id, {
              expires: 1,
              secure: true,
              sameSite: "Strict",
            });
            Cookies.set("user_id", response.data.data.id, {
              expires: 1,
              secure: true,
              sameSite: "Strict",
            });
            setFormData({
              email: "",
              password: "",
            });
            window.localStorage.setItem("user_id", response.data.data.id);
            navigate(`/user/onboarding/step${response.data.data.steps}`);

          }else{
            Cookies.set("token", response.data.data.token, {
            expires: 1,
            secure: true,
            sameSite: "Strict",
          });
          Cookies.set("userId", response.data.data.id, {
            expires: 1,
            secure: true,
            sameSite: "Strict",
          });
          Swal.fire({
            icon: "success",
            title: "User Logged In Successfully!",
            toast: true,
            position: "top-end",
            showConfirmButton: false,

            timer: 2000,
            timerProgressBar: true,
          });
          setFormData({
            email: "",
            password: "",
          });
          navigate("/user/home");}
          
        } else {
          Swal.fire({
            icon: "error",
            title: "User Not Found!",
            confirmButtonText: "Done",
            showConfirmButton: true,
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      {isLoading ? (
        <div className="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center z-10">
          <img src="/Images/loader.gif" className="h-16 w-16 bg-opacity-50" />
        </div>
      ) : (
        <div className="flex items-center justify-center min-h-screen bg-[#F3F2EF] py-10 px-4 sm:px-6 lg:px-8">
          <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-md relative mt-10">
            <h2 className="text-3xl font-bold mb-6 text-center">Login</h2>
            <form>
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-bold mb-1"
                  htmlFor="email"
                >
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  className="shadow appearance-none border rounded-md h-10 w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="email"
                  value={formData.email}
                  onChange={handleChange}
                  type="text"
                  placeholder="Email or phone"
                  disabled={isLoading}
                />
                <span className="text-red-500 ml-1 text-sm mb-1">
                  {error.email}
                </span>
              </div>
              <div className="">
                <label
                  className="block text-gray-700 text-sm font-bold mb-1"
                  htmlFor="password"
                >
                  Password <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <input
                    className="shadow appearance-none border rounded-md h-10 w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="password"
                    value={formData.password}
                    onChange={handleChange}
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    disabled={isLoading}
                  />
                  <i
                    className={`fas ${
                      showPassword ? "fa-eye-slash" : "fa-eye"
                    } absolute right-3 top-3 text-gray-500 cursor-pointer`}
                    onClick={() => setShowPassword(!showPassword)}
                  ></i>
                </div>

                <span className="text-red-500 ml-1 text-sm mb-1">
                  {error.password}
                </span>
              </div>
              <div className="mb-2 text-left">
                <Link
                  to="/user/forgot-password"
                  className="text-[#0A66C2] text-sm"
                >
                  Forgot password?
                </Link>
              </div>
              <div className=" ">
                <label className="inline-flex items-center">
                  <input
                    type="checkbox"
                    className="form-checkbox size-4 text-blue-500"
                    disabled={isLoading}
                  />
                  <span className="ml-2 text-gray-700 text-sm">
                    Keep me logged in
                  </span>
                </label>
              </div>
              <div className="mb-8 mt-8 flex flex-col items-center">
                <button
                  className={`bg-[#0A66C2] hover:bg-blue-700 text-white text-xl font-bold py-2 px-4 h-12 rounded-full w-56 ${
                    isLoading ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                  type="button"
                  onClick={handleSubmit}
                  disabled={isLoading}
                >
                  {isLoading ? "Signing in..." : "Sign in"}
                </button>
              </div>
              <div className="flex items-center justify-center mb-4">
                <hr className="w-full border-gray-300" />
                <span className="px-2 text-black">or</span>
                <hr className="w-full border-gray-300" />
              </div>

              {/* <div className="mb-8 mt-8">
                <button
                  className="bg-white border border-gray-300 text-[#5E5E5E] font-bold py-2 px-4 rounded-full w-full flex items-center justify-center"
                  type="button"
                  disabled={isLoading}
                >
                  <img
                    src="/Images/login/google 1.png"
                    alt="Google logo"
                    className="mr-2"
                  />
                  Continue with Google
                </button>
              </div> */}

              <div className="mb-8 mt-8">
                <GoogleLogin
                  onSuccess={async (credentialResponse) => {
                    try {
                      const googleToken = credentialResponse.credential;

                      const response = await axios.post(
                        BaseUrl + "google-login",
                        {
                          token: googleToken,
                        }
                      );

                      if (response.data.status === 200) {
                        Cookies.set("token", response.data.data.token, {
                          expires: 1,
                          secure: true,
                          sameSite: "Strict",
                        });
                        Cookies.set("userId", response.data.data.id, {
                          expires: 1,
                          secure: true,
                          sameSite: "Strict",
                        });

                        Swal.fire({
                          icon: "success",
                          title: "Logged in with Google!",
                          toast: true,
                          position: "top-end",
                          showConfirmButton: false,
                          timer: 2000,
                          timerProgressBar: true,
                        });

                        navigate("/user/home");
                      }
                    } catch (error) {
                      Swal.fire({
                        icon: "error",
                        title: "Google Login Failed!",
                        confirmButtonText: "Try again",
                      });
                      console.error("Google login error", error);
                    }
                  }}
                  onError={() => {
                    Swal.fire({
                      icon: "error",
                      title: "Google Login Cancelled",
                      confirmButtonText: "Retry",
                    });
                  }}
                />
              </div>

              <div className="text-center">
                <span className="text-gray-700">New to Ls LinkedIn? </span>
                <Link to="/user/register" className="text-[#0A66C2]">
                  Join now
                </Link>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
